<template>
  <layout-customs>
    <div id="page-content-wrapper" class=""></div>

    <!-- Page Content -->
    <div id="page-content-wrapper" v-if="page == 'page2'" >
        <div class="container-fuild landing-row">
            <div class="container">
                <div class="row">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-7">
                        <h1 class="page-header">Accelerate the Energy transiction</h1>
                        <p class="top-p">Greeneum is a P2P platform and marketplace for the new green energy market:</p>
                        <ul>
                            <li>Validation, certificates & Energy trading</li>
                            <li>Grid optimisation & resilience</li>
                            <li>Proprietary Blockchain & AI</li>
                        </ul>
                        <p><a href="" class="btn-w">Whitepaper</a><a href="" class="btn-w">How it works</a></p>
                        <p><a href="" class="btn-w-get">Get GREEN</a></p>
                    </div>
                    <div class="col-lg-4">
                        <a href="" class="btn-w">I'm a prosumer</a>
                    </div>

                </div>
            </div>
        </div>

        <div class="container">
            <div class="col-lg-12 special-token-line">
                <h1>Special GREEN Token Distribution</h1>
                <div class="line progress-line">
                    <span class="progress-color"></span>
                    <span class="progress-start">0</span>
                    <span class="progress-box">1.500.000 softcap</span>
                    <span class="progress-end">12.000.000 hardcap</span>
                </div>
                  <div class="col-lg-7 time-rem">Time remaining: 136h 34” 25’</div>
                <div class="col-lg-5 btn-box"><a href="" class="btn-w-get">Get GREEN</a>
                </div>
            </div>
            <div class="row landing-row2">
                <div class="col-lg-12">
                    <h5>Greeneum is a decentralized network that combines Blockchain, Smart Contracts and AI to validate, monetize, optimize and incentivize <span class="color-green">GREEN</span> energy.</h5>
                </div>
            </div>

            <div class="row landing-row3">
                <div class="col-lg-3">
                    <span class="title-header">Blockchain Trading</span>
                    <span class="img-box"><img src="/static/dist/images/Greeneum-Green-Certificates.png"></span>
                    <p>Security and speed is essential when it comes to efficient buying.It all begins with our API, which connects you effortlessly to the Greeneum blockchain for easy trading.</p>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-3">
                    <span class="title-header">Energy Optmization</span>
                    <span class="img-box"><img src="/static/dist/images/Greeneum-Green-Certificates.png"></span>
                    <p>Unified metrics are key to driving efficient energy usage. Greeneum utilizes highly-secure data collection techniques to compile and validate output from energy systems and environmental data domains.</p>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-3">
                    <span class="title-header">Proprietary Technology</span>
                    <span class="img-box"><img src="/static/dist/images/Greeneum-Green-Certificates.png"></span>
                    <p>Greeneum’s proprietary targeted Artificial Intelligence is based on the most accurate and efficient machine learning algorithms in the energy market.</p>
                </div>
            </div>

            <div class="row landing-row4">
                <h4 class="color-green">Contribute to a booming market. Incentivize a greener future.</h4>
                <div class="col-lg-5">
                    <span class="title-header">Bounty Program</span>
                    <p>Greeneum’s proprietary targeted Artificial Intelligence is based on the most accurate and efficient machine learning algorithms in the energy market.</p>
                    <span class="img-box"><a href="" class="btn-b-green">Participate</a></span>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-5">
                    <span class="title-header">Affiliate Program</span>
                    <p>Greeneum’s proprietary targeted Artificial Intelligence is based on the most accurate and efficient machine learning algorithms in the energy market.</p>
                    <span class="img-box"><a href="" class="btn-b-green">Become an affiliate</a></span>
                </div>
                <span class="col-lg-12 btn-box"><a href="" class="btn-green">Get GREEN</a></span>
            </div>

        </div>

        <div class="container-fuild landing-row5">
            <div class="container">
                <h1 class="page-header">Partners</h1>
                <span class="img-box"><img src="/static/dist/images/partners-list.png"></span>
                <h1 class="page-header second">Use of Funds</h1>
                <div class="line">
                    <div class="col-lg-6">
                        <span class="img-box"><span></span></span>
                    </div>
                    <div class="col-lg-6">
                        <span class="img-box"><span></span></span>
                    </div>
                    <span class="col-lg-12 btn-box"><a href="" class="btn-green">Get GREEN</a></span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row landing-row6">
                <div class="col-lg-12">
                    <a href=""><i class="fa fa-envelope-o" aria-hidden="true"></i></a>
                    <a href=""><i class="fa fa-twitter" aria-hidden="true"></i></a>
                    <a href=""><i class="fa fa-reddit-alien" aria-hidden="true"></i></a>
                    <a href=""><i class="fa fa-facebook" aria-hidden="true"></i></a>
                    <a href=""><i class="fa fa-linkedin" aria-hidden="true"></i></a>
                    <a href=""><i class="fa fa-dribbble" aria-hidden="true"></i></a>
                </div>
                <div class="col-lg-12">
                    <h4>JOIN US IN BUILDING A GREEN FUTURE</h4>
                    <p>back to ted disclaimer terms of use</p>
                </div>
                <div class="line">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="control-label">Name *</label>
                            <input type="text" class="form-control" placeholder="First Name">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="control-label">&nbsp;</label>
                            <input type="text" class="form-control" placeholder="Last Name">
                        </div>
                    </div>
                </div>
                <div class="line">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label class="control-label">Email Address *</label>
                            <input type="text" class="form-control" placeholder="First Name">
                        </div>
                    </div>
                </div>
                <div class="line">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label class="control-label">Message *</label>
                            <textarea class="form-control" rows="5"></textarea>
                        </div>
                    </div>
                </div>
                <span class="col-lg-12 btn-box"><a href="" class="form-go" v-on:click="save()">SUBMIT</a></span>
            </div>
        </div>
        <div class="container-fuild">
            <div class="row landing-row-footer">
                <div class="col-lg-12">
                    <p>2019 &copy; Greeneum All Rights Reserved.</p>
                </div>
            </div>
        </div>
    </div>


    <div id="page-content-wrapper" v-if="page == 'page1'" class="container ctb_box">
      <div class="saftform">
        <h1>KYC Form</h1>
        <div class="description ta-center">
          <h3>Our procedure guarantees Greeneum's Community Value and therefore our Tokens.</h3>
          <h3>Thanks in advance for your time and contribution!</h3>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="control-label">Full Legal Name*</label>
                <input type="text" placeholder="First Name" v-validate="'required'" name="firstName" v-model="userData.firstName" class="form-control" :class="{'error-input': errors.has('firstName')}">
                <span class="error" v-if="errors.has('firstName')">{{errors.first('firstName')}}</span>
              </div>
            </div>
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="control-label">&nbsp;</label>
                <input type="text" placeholder="Last Name" name="lastName" v-validate="'required'" v-model="userData.lastName" class="form-control" :class="{'error-input': errors.has('lastName')}">
                <span class="error" v-if="errors.has('lastName')">{{errors.first('lastName')}}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="control-label">Email Address*</label>
                <input type="text" v-if="!token" v-model="userData.email" class="form-control" name="email" v-validate="'required|email'" :class="{'error-input': errors.has('email')}">
                <input type="text" v-else readonly v-model="userData.email.trim()" class="form-control" name="email" v-validate="'required|email'" :class="{'error-input': errors.has('email')}">
                <span class="error" v-if="errors.has('email')">{{errors.first('email')}}</span>
              </div>
            </div>          
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="control-label">Country*</label>
                                        <select
                                                name="country"
                                                v-validate="'required'"
                                                v-model="userData.country"
                                                data-vv-as="Country"
                                                class="form-control"
                                                :class="{'error-input': errors.has('country')}"
                                        >
                                            <option value="" disabled selected></option>
                                            <option
                                                v-for="(country, key) in countries"
                                                :value="country.name"
                                            >{{country.name}}</option>
                                        </select>
                                        <span
                                            class="error"
                                            v-if="errors.has('country')"
                                        >The Country field is requered.</span>
              </div>                          
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-8">
              <div class="form-group">
                <label class="control-label">Address*</label>
                <input type="text" v-model="userData.address" class="form-control" name="address" v-validate="'required'" :class="{'error-input': errors.has('address')}">
                <span class="error" v-if="errors.has('address')">{{errors.first('address')}}</span>
              </div>
            </div>   
          </div>  
          <div class="row">
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="control-label">Your ID / Passport Copy for KYC*</label>
                <input
                                                type="file"
                                                class="form-control"
                                                id="file1"
                                                name="idPassportForKYC"
                                                v-validate="'required'"
                                                @change="onFileChange"
                                                ref="idPassportForKYC"                                                
                                                data-vv-as="Your ID / Passport Copy for KYC"
                                                placeholder="Choose PDF or JPEG file"
                                                accept=".pdf, .jpeg"                                                
                                                :class="{'error-input': errors.has('idPassportForKYC')}"
                                              >
                <span class="error" v-if="errors.has('idPassportForKYC')">{{errors.first('idPassportForKYC')}}</span>
              </div>
            </div>
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="control-label">Your utility bill/user address</label>
                 <input
                                                type="file"
                                                class="form-control"
                                                id="fileBill"
                                                name="utilityBill"
                                                v-validate=""
                                                @change="onFileBillChange"
                                                ref="utilityBill"                                                
                                                data-vv-as="Your utility bill/user address"
                                                placeholder="Choose PDF or JPEG file"
                                                accept=".pdf, .jpeg"
                                                :class="{'error-input': errors.has('utilityBill')}"
                                              >
                <span class="error" v-if="errors.has('utilityBill')">{{errors.first('utilityBill')}}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-8">
              <div class="form-group">
                <label class="control-label">GREEN BEP20 Wallet Address*</label>
                <input type="text" class="form-control" name="walletGREENBEP20" v-model="userData.walletGREENBEP20" v-validate="'required'" :class="{'error-input': errors.has('walletGREENBEP20')}">
                <span class="error" v-if="errors.has('walletGREENBEP20')">{{errors.first('walletGREENBEP20')}}</span>
                <!-- <input type="checkbox" name="accept" class="cbxRequired" v-validate="'required'" :class="{'error-input': errors.has('accept')}" data-vv-as="Terms and Conditions"> I represent an organisation / group of investors -->
              </div>
            </div>
            <!-- <div class="col-xs-12 col-md-4">
              <div class="form-group">
                <label class="control-label">Currency*</label>
                <div class="sqs-block-button-container" data-button-size="small">
                  <button id="buttonBTC" @click="selectAnotherCoinTypeClick('BTC', '#buttonBTC')" class="currency-button select">BTC</button>
                  <button id="buttonETH" @click="selectAnotherCoinTypeClick('ETH', '#buttonETH')" class="currency-button">ETH</button>
                  <button id="buttonEOS" @click="selectAnotherCoinTypeClick('EOS', '#buttonEOS')" class="currency-button">EOS</button>
                </div>
              </div>
            </div>-->
          </div> 
     <!--      <div class="row">
            <div class="col-xs-12 col-md-7">
              <div class="form-group">
                <label class="control-label">Contribution amount in selected currency*</label>
                <input type="text" class="form-control" v-model="userData.contributionAmount" name="contributionAmount" v-validate="'required'" :class="{'error-input': errors.has('lastName')}">
                <span class="error" v-if="errors.has('contributionAmount')">{{errors.first('contributionAmount')}}</span>

              </div>
            </div>
            <div class="col-xs-12 col-md-5 col-bonus">
              <div class="form-group">
                <label class="control-label">&nbsp;</label>
                <div class="col-bonus-text">
                  <!-- <label class="control-label">Bonus: 30%</label> -->
                <!-- </div>
              </div>
            </div>
          </div> -->
        <!--   <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label font-style-italic">Please DO NOT send crypto from any online exchanges. We will not be able to identify the transaction when sending from online exchanges.</label>
                <label class="control-label font-style-italic">Minimal investment: 0.05 BTC, 0.5 ETH, 1000EOS.</label>
              </div>
            </div>
          </div> -->
          <!-- <div class="row">
            <div class="col-xs-12 col-md-7">
              <div class="form-group">
                <label class="control-label">GREEN ERC20 destination wallet address*</label>
                <input type="text" class="form-control" v-model="userData.walletAddressGREEN" name="walletAddressGREEN" v-validate="'required'" :class="{'error-input': errors.has('walletAddressGREEN')}">
                <span class="error" v-if="errors.has('walletAddressGREEN')">{{errors.first('walletAddressGREEN')}}</span>

              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label font-style-italic">Please make sure that the wallet that you are placing in this field is an ERC20 wallet under your control. Wallets on exchanges or that are not ERC20 will not receive the GREEN tokens, which will end in loss of your funds.</label>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="checkbox">
                  <label class="cbxLabel">
                    <input type="checkbox" name="resident" class="cbxRequired" v-validate="'required'" :class="{'error-input': errors.has('resident')}"> I am neither a citizen, resident or green card holder of the United States of America, Afghanistan, Bosnia And Herzegovina, Cayman Islands, Democratic People's Republic of Korea (DPRK), Ethiopia, Iran, Iraq, Pakistan, Sri Lanka, Syria, Trinidad and Tobago, Tunisia, Uganda, Yemen*
                  </label>
                  <span class="error" v-if="errors.has('resident')">{{errors.first('resident')}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <div class="checkbox">
                  <label class="cbxLabel">
                    <input type="checkbox" name="accept" class="cbxRequired" v-validate="'required'" :class="{'error-input': errors.has('accept')}" data-vv-as="Terms and Conditions"> By Clicking on Submit, I Accept Terms and Conditions generated in this SAFT*
                  </label>
                </div>
                <span class="error" v-if="errors.has('accept')">{{errors.first('accept')}}</span>
              </div>
            </div>
            <span class="col-lg-12 btn-box">
              <a class="form-go" v-on:click="save()">Submit</a>
            </span>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button v-on:click="backToGREEN()" type="button" class="btn btn-link" v-if="!token">Back</button>
            </div>
          </div>
           <div class="row">
            <div class="col-md-12">
               <a href="greeneum.net">greeneum.net</a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div id="page-content-wrapper" v-if="page == '3'" class="container ctb_box">
      <div class="saftform">
        <h1 class="sentmsg">Thank you for the purchasing Greeneum token. Your transaction will be  confirmed shortly and you will receive an email notification with the transaction confirmation.</h1>
      </div>
    </div>  

    <div id="page-content-wrapper" v-if="page == '5'" class="container ctb_box">
      <div class="saftform">
        <h1 class="sentmsg">Thank you for the fulling KYC Form. You will receive an email notification with the registration data.</h1>
      </div>
    </div>

  </layout-customs>
</template>


<script>
import LayoutCustoms from './../../layouts/LayoutDefault.vue';
import Api from './../../services/api'

export default {
  name: 'Contribute',
  components: {
    LayoutCustoms,
    Api,
  },
  data() {
    return {
      page: "page1",
      userData: {
        firstName: '',
        lastName: '',
        address: '',
        email: '',
        offset: new Date().getTimezoneOffset(),        
        // city: "",
        // stateProvince: "",
        // postalZipCode: "",
        country: '',
        typeOfProfile: 'affiliate',
        // walletAddress: '',
        // walletAddressETH: '',
        // walletAddressEOS: '',
        // wallet: '',
        contributionAmount: null,
        // walletAddressGREEN: '',
        idPassportForKYC: [],
        utilityBill: '',
      },
      token: '',
      idProject: '',
      countries: [],
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    backToGREEN() {
      // this.page = "page1";
      // this.scrollToTop();
      this.$router.go(-1);
    },
    getGREEN() {
      this.page = "page2";
      this.scrollToTop();
    },
    generateTokenCode() {
      return URL.createObjectURL(new Blob([]))
        .slice(-36)
        .replace(/-/g, '')
    },
    onFileChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.userData.idPassportForKYC = files
    },
    onFileBillChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.userData.utilityBill = files
    },
    selectAnotherCoinTypeClick (type, btn){
      $('.currency-button').removeClass('select')
      this.walletAddress = this.walletAddressETH = this.walletAddressEOS = ''
      $(btn).addClass('select')
      if (type=='BTC') this.userData.walletAddress = this.userData.wallet
      if (type=='ETH') this.userData.walletAddressETH = this.userData.wallet      
      // if (type=='EOS') this.userData.walletAddressEOS = this.userData.wallet
    },
    save() {      
      this.$validator.validateAll().then(result => {
        if (result) {
          this.userData.offset = new Date().getTimezoneOffset()
          this.userData.token = this.generateTokenCode()
          // if (this.userData.walletAddress == '' && this.userData.walletAddressEOS == '' && this.userData.walletAddressETH == ''  ) this.userData.walletAddress = this.userData.wallet
          // this.userData.country = this.$refs.selectCountry.value        

          var formData = new FormData()
          for (var key in this.userData) {
            formData.append(key, this.userData[key])
          }
          if (this.userData.idPassportForKYC)
            for (var i = 0; i < this.userData.idPassportForKYC.length; i++) {
              formData.append(
                'idPassportForKYC'+i,
                this.userData.idPassportForKYC[i]
              )
            } 
          if (this.userData.utilityBill)
            for (var i = 0; i < this.userData.utilityBill.length; i++) {
              formData.append(
                'utilityBill'+i,
                this.userData.utilityBill[i]
              )
            } 

          if (this.token)  
            this.$http.post('/save_owner_data', formData).then(
                response => {         
                  this.page=5;
                  this.afterConfirmProject();
                },
                error => {
                  this.validationMessage = error.body.message
                }
              )
          else
              this.$http.post('/save_contribute', formData).then(
                response => {         
                  this.page=3;              
                },
                error => {
                  this.validationMessage = error.body.message
                }
              )
          return
        }
      })
    },
    async afterConfirmProject(){        
        var res = await Api.confirmedOwnerProjectById(this.idProject)
    },
  },
  mounted(){
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ********************* start ********************* ")
    console.log(this.$route.params)
    // var currency = this.$route.query.coin, btn = "#button" + currency
    // this.selectAnotherCoinTypeClick(currency, btn)
  },
  async created() {
    try {
        console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ********************* start ********************* ")
        console.log(this.$route.params)

        this.userData.firstName = (this.$localStorage.get('userName') != null) ? this.$localStorage.get('userName').split(' ')[0] : ""
        this.userData.lastName = (this.$localStorage.get('userName') != null) ? this.$localStorage.get('userName').split(' ')[1] : ""
        this.userData.email = this.$localStorage.get('userEmail')
        this.userData.address = this.$localStorage.get('address')
        this.userData.country = this.$localStorage.get('country')
        // this.$refs.selectCountry = this.$localStorage.get('country')
        this.userData.idPassportForKYC = this.$localStorage.get('idPassportForKYC')
        this.$refs.idPassportForKYC = this.$localStorage.get('idPassportForKYC')
        this.userData.utilityBill = this.$localStorage.get('utilityBill')
        this.$refs.utilityBill = this.$localStorage.get('utilityBill')

        console.log(this.$localStorage.get('userName'), this.$localStorage.get('idPassportForKYC'), this.$refs.idPassportForKYC, this.$route.params.token)

        if (this.$route.params.token) {
            this.token = this.$route.params.token;
            var owner = (await Api.getUserByToken(this.$route.params.token)).data.user
      
            var pos = ((owner.fullName).indexOf(' ') > -1) ? (owner.fullName).indexOf(' ') : (owner.fullName).length-1, 
                lastName = (pos == ((owner.fullName).length-1)) ? "" : (owner.fullName).substr(pos+1, (owner.fullName).length-1)

            this.userData.firstName = (owner.fullName).substr(0, pos)
            this.userData.lastName = lastName
            this.userData.email = owner.email
            this.userData.address = owner.address
            this.userData.country = owner.country
            // this.$refs.selectCountry = owner.country
            this.userData.walletGREENBEP20 = owner.walletGREENBEP20
            this.userData.idPassportForKYC = (owner.idPassportForKYC.length > 0) ? owner.idPassportForKYC[0] : ""
            this.$refs.idPassportForKYC = (owner.idPassportForKYC.length > 0) ? owner.idPassportForKYC[0] : ""
            
            this.userData.utilityBill = owner.utilityBill
            this.$refs.utilityBill = owner.utilityBill

            this.idProject = this.$route.params.id
        }
        this.countries = require('./../../data/country.js')
    } catch (error) {           
      console.log("error KYC")
      console.error(error)
    }    
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Contribute/index.vue